import React, { useState } from "react";
import { Container, Image, Row, Col, Button, Card } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { granulation, granulationContaBlender, granulationDoubleConeBlender, granulationOctagonalBlender, granulationRibbonBlender, granulationVBlender } from "assets";
import { ShareCard, FeaturePoints } from "components";
import { useMediaQuery } from "react-responsive";


const Blender = () => {
    const navigate = useNavigate();
    const large = useMediaQuery({ query: "(min-width: 992px)" });
    const medium = useMediaQuery({ query: "(min-width: 768px)" });
    const share_url = window.location.href;
    const allTypes = ["Conta", "Double Cone", "Octagonal", "Ribbon", "V"]
    const allDescriptions = [
        {
            id: 1,
            title: "Conta",
            description: "The Conta Blender is your go-to solution for effective and uniform mixing, lubricating, and blending of dry powder and granules, ensuring a homogeneous blend that enhances the flowability of materials for tablet and capsule production. This blender shuffles the product thoroughly, resulting in a seamlessly blended mixture.",
            image: granulationContaBlender,
            keyFeatures: [
                "Outperforms other tumbling-type blenders in mixing efficiency",
                "Flexible handling of different batch volumes with various bin sizes",
                "The working area is secured by a railing with a bin entry gate",
                "Bin entry gate and bin position interlock to prevent accidents",
                "Convenient home position for easy loading and unloading of bins",
                "Built-in butterfly valve for effortless discharge",
                "PLC-based operation with optional color HMI for user-friendly control"
            ]
        },
        {
            id: 2,
            title: "Double Cone",
            description: "Double Cone Blenders stand out as the ultimate equipment for achieving homogeneous blending of powders, serving diverse industries such as chemical, food, and pharmaceutical. With capacities ranging from 50 to 1500 liters, variable rotational speeds, and adaptable materials of construction, there's a Powder Blender tailored to suit every application. This efficient and versatile closed double cone blender excels in granular and dry powder blending, featuring either Direct or Variable Speed Drives that provide a low shear product mixing environment.",
            image: granulationDoubleConeBlender,
            keyFeatures: [
                "Conical shape at both ends ensures uniform mixing and easy discharge",
                "Statically balanced cone safeguards the gearbox and motor from excessive loads",
                "Wide opening for powder loading and a butterfly valve for convenient discharge",
                "Optional paddle-type baffles on the shaft for enhanced mixing, uniform blending, and de-agglomeration",
                "Flame-proof electrical components available as an option",
                "Optional Variable Frequency Drive for speed control"
            ]
        },
        {
            id: 3,
            title: "Octagonal",
            description: "The Octagonal Blender is your solution for efficient and uniform mixing, as well as lubricating dry powders and granules. The resulting blend, with its improved flowability, is ideal for tabletting or capsulation processes. This blender ensures an intimate shuffle of the product, achieving a homogeneous blend.",
            image: granulationOctagonalBlender,
            keyFeatures: [
                "Effective blending facilitated by mixing baffles",
                "Quick cleaning of mixing baffles for enhanced efficiency",
                "Easy and rapid cleaning of the product shell",
                "Optional programmable logic controller (PLC) for advanced control",
                "Optional flameproof construction for added safety"
            ]
        },
        {
            id: 4,
            title: "Ribbon",
            description: "The Ribbon Blender, a compact and light-duty mixer, is engineered to achieve a convection mechanism for blending pre-processed powder components like dried granules and pre-sieved powders. This low-shear mixer is an ideal choice for solid-solid mixing, and it can also handle solid-liquid mixing when high shearing force is not required.",
            image: granulationRibbonBlender,
            keyFeatures: [
                "Available in two shapes - U & W",
                "Monoblock design to prevent cross-contamination",
                "Bearing mounted on lanterns outside the mixing zone",
                "Air purge on side entry seals for enhanced sealing",
                "Continuous ribbon design ensures complete discharge",
                "Variable frequency drive for precise shear energy control",
                "Belt-driven power transmission",
                "Top-mounted charging port and side discharge arrangement reduce material handling",
                "Optional paddle-style agitator for blending fragile materials",
                "Optional lance-type injectors for liquid spraying"
            ]
        },
        {
            id: 5,
            title: "V",
            description: "The Rotary, tumble-type V Blender, also known as the Y Blender, stands out with its innovative design featuring manholes for convenient product loading. The cylindrical 'V' curve not only allows easy access to internal areas but also facilitates better cleaning. The distinctive 'V' shape promotes higher shear mixing without attrition and particle regeneration, resulting in shorter mixing and blending times. This makes it particularly suitable for fragile granules where precise control over fines percentages is essential. Enjoy efficient and controlled blending with this thoughtfully designed V Blender.",
            image: granulationVBlender,
            keyFeatures: [
                "Easy to clean with minimal maintenance requirements",
                "Integrated Vacuum loading option for added convenience",
                "Bin charging system can be incorporated for a dust-free closed environment during charging and discharging",
                "Ideal for blending dry powders and granulated products",
                "The V-blender's shape ensures near-complete discharge of product material",
                "Absence of shaft projection eliminates the risk of product contamination"
            ]
        },
    ]
    const [blenderType, setBlenderType] = useState(allTypes[0]);
    const [selectedDescription, setSelectedDescription] = useState(allDescriptions[0])

    return (
        <>
            <Container
                fluid
                className="d-flex justify-content-center align-items-center px-0 py-3"
                style={{ minHeight: "50vh" }}
            >
                <Image
                    className="position-absolute w-100 h-100"
                    src={granulation}
                    alt="Granulation"
                    style={{ objectFit: "cover", zIndex: "-1" }}
                />
                <div
                    className="position-absolute w-100 h-100"
                    style={{ backgroundColor: "rgba(0, 0, 0, 0.5)", zIndex: "-1" }}
                ></div>
                <Container
                    className={`mt-5 pt-5 d-flex flex-column  ${large ? "justify-content-center align-items-center" : ""
                        }`}
                >
                    <div className="px-lg-3 text-primary body-text2">
                        <b>Granulation</b>
                    </div>
                    <div className="page-header text-white my-lg-3 my-2">Blender</div>
                    <div className="subtitle-400 text-secondary text-lg-center text-white mb-5">
                        Your needs, our expertise. Find the perfect solution.
                    </div>
                    <div
                        className={`d-flex justify-content-center align-items-center ${large ? "" : "flex-column"
                            }`}
                    >
                        <Button
                            className={`bg-transparent text-primary manrope-600 ${large ? "" : "my-4"
                                }`}
                            style={{
                                paddingLeft: 40,
                                paddingRight: 40,
                                borderRadius: 30,
                                height: 60,
                            }}
                            onClick={() => navigate(`/contact-us`)}
                        >
                            Contact Us
                        </Button>
                    </div>
                </Container>
            </Container>
            <Container fluid className="bg-white">
                <Container
                    className="my-5"
                    style={{ minHeight: "100vh" }}
                >
                    <div className="subtitle d-flex flex-row mt-5 pt-5">
                        <a className="manrope-400 text-decoration-none" href="/solutions/granulation">
                            Granulation
                        </a>
                        <span className="text-gray">
                            {">"}
                        </span>
                        <span className="text-gray">
                            Blender
                        </span>
                    </div>
                    <div className="d-flex justify-content-center align-items-center mt-4 mb-5">
                        {large ?
                            <Card className="p-2 d-flex flex-row border-0 bg-tertiary" style={{ borderRadius: 40 }}>
                                {allTypes.map((type, index) => {
                                    return (
                                        <Button
                                            className={`border-0 manrope-600 ${blenderType === type ? "bg-primary text-tertiary" : "bg-transparent text-primary"} ${large ? "" : "w-100"}`}
                                            style={{
                                                paddingLeft: blenderType === type ? 40 : 20,
                                                paddingRight: blenderType === type ? 40 : 20,
                                                borderRadius: 25,
                                                height: 50,
                                            }}
                                            onClick={() => {
                                                setBlenderType(type)
                                                setSelectedDescription(allDescriptions[index])
                                            }}
                                        >
                                            {type} Blender
                                        </Button>
                                    )
                                })}
                            </Card>
                            :
                            <dic>
                                {allTypes.map((type, index) => {
                                    return (
                                        <Button
                                            className={`border-0 manrope-600 me-2 mb-2 ${blenderType === type ? "bg-primary text-tertiary" : "bg-secondary text-primary"}`}
                                            style={{
                                                paddingLeft: blenderType === type ? 40 : 20,
                                                paddingRight: blenderType === type ? 40 : 20,
                                                borderRadius: 25,
                                                height: 50,
                                            }}
                                            onClick={() => {
                                                setBlenderType(type)
                                                setSelectedDescription(allDescriptions[index])
                                            }}
                                        >
                                            {type} Blender
                                        </Button>
                                    )
                                })}
                            </dic>
                        }
                    </div>
                    <Row>
                        <Col sm={12} md={4} lg={4}>
                            <Image
                                className="w-100"
                                src={selectedDescription.image}
                                alt={selectedDescription.title}
                                style={{ borderRadius: 20 }}
                            />
                        </Col>
                        <Col sm={12} md={8} lg={8}>
                            <h3 className="text-tertiary">Introduction</h3>
                            <div className="bg-primary" style={{ width: 100, height: 4 }} />
                            <div className="subtitle text-gray mt-4" style={{ textAlign: 'justify' }}>
                                {selectedDescription.description}
                            </div>
                            <div className="d-flex mt-4">
                                <ShareCard share_url={share_url} bottom={true} />
                            </div>
                        </Col>
                    </Row>
                    <h3 className={`${medium ? "mt-5" : ""}`}>Key Features :</h3>
                    <FeaturePoints items={selectedDescription.keyFeatures} />
                </Container>
            </Container>
        </>

    );
};

export default Blender;
